function initializeViewer() {
  jQuery(".mad-slider__container--image,.mad-slider__container--image-row").each(function () {
      const container = jQuery(this);
      const htmlStructure = createHtmlStructure(container);

      const viewer = new Viewer(htmlStructure, {
          toolbar: {
              zoomIn: true, // Enable zoom in
              zoomOut: true, // Enable zoom out
              prev: true, // Enable previous button
              next: true, // Enable next button
              play: false, // Disable play button
              rotateLeft: false, // Disable rotate left
              rotateRight: false, // Disable rotate right
              flipHorizontal: false, // Disable flip horizontal
              flipVertical: false // Disable flip vertical
          },
          title: false, // Remove image name
          navbar: true, // Enable the navbar
          zoomRatio: 0.3 // Increase zoom speed (default is 0.1)
      });

      container.find(".mad-slider__body").each(function (index) {
          addClickCallback(jQuery(this), viewer, index);
      });
  });
}

function createHtmlStructure(container) {
  const htmlStructure = document.createElement("div");

  container.find(".mad-slider__body").each(function () {
      const backgroundImage = jQuery(this).css("background-image");
      const urlMatch = backgroundImage.match(/url\("?(.*?)"?\)/);

      if (urlMatch && urlMatch[1]) {
          const imageUrl = urlMatch[1];
          const img = document.createElement("img");
          img.src = imageUrl;
          img.alt = "Slider Image";
          htmlStructure.appendChild(img);
      }
  });

  return htmlStructure;
}

function addClickCallback(sliderBody, viewer, index) {
  sliderBody.on("click", () => {
      viewer.view(index);
  });
}

function adjustViewerContainerMargin() {
  const adminBar = jQuery("#wpadminbar");
  const viewerContainer = jQuery(".viewer-container");

  if (adminBar.length && viewerContainer.length) {
      const adminBarHeight = adminBar.outerHeight();
      addMarginTopStyle(adminBarHeight);
  }
}

// Main callback
$dependencyManager.addDependencyCallback('viewerjs', () => {
  initializeViewer();
});
